/**
 * Table object_type column possible values
 */
export enum SqlObjType {
    Accounts = 'accounts',
    Visit = 'visit',
    Question = 'question',
}

/**
 * Attachments table object_type column possible values
 */
export enum AttachmentObjType {
    /**
     * the object_ref column value will be `audit_ques_seq`
     */
    Question = 'audit_questions',
    /**
     * the object_ref column value will be `audit_no`
     */
    
    Audit = 'audits',
    /**
     * the object_ref column value will be `visit_no`
     */
    Signature = 'visits',
    /**
     * the object_ref column value will be `audit_no`
     */
    AuditAttempted = 'audits'
}


/**
 * Attachments table attachment_type column possible values
 */
export enum AttachmentType {
    Question = 'file',
    Signature = 'signature',
    Attempted = 'audit_attempted',
    Audits = 'audit_file'
}


